export default "/images/4fb3c9f49664d63ed5da23f0a570937c.avif";